var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getTextBlocks.data)?_c('DocumentContent',{attrs:{"title":_vm.getContent('terms-use-title'),"content":_vm.getContent('terms-use-content')}}):_c('Preloader')}
var staticRenderFns = []

export { render, staticRenderFns }